import React from 'react';

const LoadingText = props => (
  <div
    className="Placeholder-text"
    style={{
      width: `${props.width}%`,
    }}
  />
);

const LoadingRow = props => (
  <form className="FlexboxTable-row">
    <div className="FlexboxTable-cell RelatedUrlsTable-leftCell">
      <LoadingText width={props.leftWidth} />
    </div>
    <div className="FlexboxTable-cell FlexboxTable-cell--containsRows d-f fd-c">
      <div className="FlexboxTable-row">
        <div className="FlexboxTable-cell d-f jc-sb ai-c">
          <LoadingText width={props.rightWidth} />
        </div>
      </div>
    </div>
  </form>
);

const LoadingTable = () => (
  <div className="RelatedUrlsTableBody FlexboxTable-body">
    <LoadingRow leftWidth="52" rightWidth="75" />
    <LoadingRow leftWidth="75" rightWidth="25" />
    <LoadingRow leftWidth="35" rightWidth="55" />
  </div>
);

export default LoadingTable;
